<template>
    <div class="ad">
<!--        <img :src="url || 'https://misc.xjy.cn/accelerator/growth/ad_qrcode_gudian.png'">-->
    </div>
</template>

<script>
export default {
  props:['url'],
}
</script>

<style lang="scss">
.ad {
    width: 100%;
    text-align: center;
    padding: 30px;

    img {
      width: 100%;
        //width: 582px;
        //height: 578px;
    }
}
</style>
